export const MIN_ACCOUNT_NUMBER = 3;
export const MAX_ACCOUNT_NUMBER = 10;
export const MAX_BSB_NUMBER = 6;
export const MAX_NAME = 50;
export const MAX_NICKNAME = 25;
export const NUMBER_REGEX = /^[0-9]+$/;
